import { ListManagerCalendarConstants } from "../Constants/ListManagerCalendarConstants";

const { ActionTypes } = ListManagerCalendarConstants; 

export const saveUserEventFavourite = (osid, is_starred, event_name, event_type, event_date) => ({
    type: ActionTypes.SAVE_USER_EVENT_FAVOURITE,
    osid,
    is_starred,
    event_name,
    event_type,
    event_date
})
